// Ciappy Shop: carrello (Ajax API di Shopify), caselle che si appoggiano, «prendi tutto», scheda prodotto, carrello, menu.
// Senza script il sito funziona lo stesso: pulsanti e link portano alle pagine native di Shopify.
(() => {
  const C = window.ciappy || { t: {} };
  const T = (k, v = {}) => (C.t[k] || '').replace(/\[(\w+)\]/g, (_, x) => (v[x] ?? ''));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = window.Shopify?.routes?.root || '/';
  // prezzi come li scrive Shopify («€59,90»): formato del negozio. ponytail: virgola o punto e senza decimali; gli altri
  // separatori di Shopify (apostrofo, spazio) escono col punto
  const money = c => (C.money || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    const v = k.includes('comma'), [i, d] = (c / 100).toFixed(k.includes('no_decimals') ? 0 : 2).split('.');
    return i.replace(/\B(?=(\d{3})+$)/g, v ? '.' : ',') + (d ? (v ? ',' : '.') + d : '');
  });
  const live = document.querySelector('[data-live]');
  const say = t => { if (!live) return; live.textContent = ''; setTimeout(() => { live.textContent = t; }, 30); };
  const api = async (path, body) => {
    const r = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body && JSON.stringify(body)
    });
    const j = await r.json();
    if (!r.ok) throw j;
    return j;
  };
  const replay = (el, cls) => { if (reduce || !el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };

  // ---------------------------------------------------------------- stato del carrello: variante → quantità
  let inCart = new Map();
  let hasPre = false, hasOk = false;
  document.querySelectorAll('.slot.is-cart[data-v]').forEach(s => inCart.set(s.dataset.v, 1));
  addEventListener('pageshow', e => { if (e.persisted) refresh(false); });  // tornando indietro la pagina può essere vecchia

  function paintCount(n, bump) {
    document.querySelectorAll('[data-count]').forEach(c => {
      c.textContent = n; c.dataset.n = n;
      c.closest('a')?.setAttribute('aria-label', n ? T(n === 1 ? 'carrello_1' : 'carrello_n', { n }) : T('carrello'));
      if (bump) replay(c, 'bump');
    });
  }
  async function refresh(bump) {
    const c = await api('cart.js');
    inCart = new Map();
    c.items.forEach(i => inCart.set(String(i.variant_id), (inCart.get(String(i.variant_id)) || 0) + i.quantity));
    hasPre = c.items.some(i => i.properties?._uscita);
    hasOk = c.items.some(i => !i.properties?._uscita);
    paintCount(c.item_count, bump);
    document.querySelectorAll('.slot[data-v]').forEach(s => paintSlot(s, false));
    paintPages();
    return c;
  }

  // ---------------------------------------------------------------- caselle
  const buyable = s => s.dataset.s === 'ok' || s.dataset.s === 'pre';
  const addable = s => buyable(s) && !s.querySelector('a.add');  // le varianti si scelgono nella scheda
  const lineFor = el => {
    const it = { id: +el.dataset.v, quantity: 1 };
    if (el.dataset.propK) it.properties = { [el.dataset.propK]: el.dataset.propV, _uscita: el.dataset.uscita };
    return it;
  };
  function paintSlot(slot, press) {
    const on = inCart.has(slot.dataset.v);
    slot.classList.toggle('is-cart', on);
    const add = slot.querySelector('button.add'), inc = slot.querySelector('.incart');
    if (add && inc) { add.hidden = on; inc.hidden = !on; }
    if (press && on) replay(slot, 'press');
  }
  function note(slot, text) {
    slot.querySelector('.note')?.remove();
    if (text) slot.querySelector('.cap').insertAdjacentHTML('beforeend', `<p class="note">${text}</p>`);
  }

  // «prendi tutto»: dice quanti prodotti aggiunge e quanto costano; solo per i preordini da 2 prodotti in su
  const todo = (pg, skip) => [...pg.querySelectorAll('.slot[data-v]')]
    .filter(s => addable(s) && !inCart.has(s.dataset.v) && s.dataset.v !== skip);
  document.querySelectorAll('[data-add-all]').forEach(b => {
    const pg = b.closest('[data-page]');
    const all = [...pg.querySelectorAll('.slot[data-v]')].filter(s => addable(s) && s.dataset.v !== b.dataset.skip);
    const pre = all.length && all.every(s => s.dataset.s === 'pre');
    b.dataset.verb = T((pre ? 'verbo_pre' : 'verbo_add') + (b.dataset.skip ? '_anche' : ''));
    b.dataset.on = all.length >= 2 && pre ? '1' : '';
  });
  function paintPages() {
    document.querySelectorAll('[data-page]').forEach(pg => {
      const slots = [...pg.querySelectorAll('.slot[data-v]')];
      const n = slots.filter(s => inCart.has(s.dataset.v)).length;
      const b = pg.querySelector('[data-add-all]');
      const skip = b?.dataset.skip;
      const rest = todo(pg, skip).length;
      pg.querySelectorAll('[data-pcount]').forEach(c => {
        c.hidden = !n;
        const r = rest ? T(skip && rest > 1 ? 'pc_altri' : 'pc_ancora', { n: rest }) : T('pc_niente');
        c.innerHTML = `${T('pc_base', { n })} <span>· ${r}</span>`;
      });
      if (!b || b.dataset.busy) return;
      b.hidden = !b.dataset.on;
      const list = todo(pg, skip), tot = list.reduce((a, s) => a + +s.dataset.p, 0);
      if (list.length) {
        delete b.dataset.go; b.disabled = false;
        b.textContent = T(list.length === 1 ? 'tutti_1' : 'tutti_n', { verbo: b.dataset.verb, n: list.length, tot: money(tot) });
      } else if (n) {
        b.dataset.go = '1'; b.disabled = false; b.textContent = T('tutti_fatto');
      } else { b.disabled = true; b.textContent = T('tutti_niente'); }
    });
  }
  paintPages();
  if (C.scelta && document.querySelector('.slot[data-v]')) refresh(false);  // serve sapere se il carrello è già misto

  async function add(items, slots) {
    const wasMixed = hasPre && hasOk;
    try {
      await api('cart/add.js', { items });
      await refresh(true);
      slots.forEach((s, i) => setTimeout(() => paintSlot(s, true), reduce ? 0 : i * 150));
      return C.scelta && !wasMixed && hasPre && hasOk ? T('misto') : '';
    } catch (e) {
      throw e.description || e.message || T('errore');
    }
  }

  document.addEventListener('click', async e => {
    const b = e.target.closest('.slot button.add');
    if (b) {
      const slot = b.closest('.slot');
      if (b.getAttribute('aria-disabled')) return;
      b.setAttribute('aria-disabled', 'true');  // non disabled: il focus resterebbe senza casa
      try {
        const mix = await add([lineFor(slot)], [slot]);
        note(slot, mix);
        say(`${T(slot.dataset.s === 'pre' ? 'preordine_nel_carrello' : 'nel_carrello', { t: slot.dataset.t })} ${mix}`);
        slot.querySelector('.out')?.focus();
      } catch (msg) { note(slot, msg); say(msg); }
      b.removeAttribute('aria-disabled');
      return;
    }
    const out = e.target.closest('.slot .out');
    if (out) {
      const slot = out.closest('.slot');
      try {
        await api('cart/change.js', { id: slot.dataset.v, quantity: 0 });
        await refresh(false);
        note(slot, '');
        say(T('tolto', { t: slot.dataset.t }));
        slot.querySelector('button.add')?.focus();
      } catch { say(T('errore')); }
      return;
    }
    const all = e.target.closest('[data-add-all]');
    if (all && all.dataset.go) { location.href = C.cartUrl; return; }
    if (all && !all.dataset.busy) {
      const list = todo(all.closest('[data-page]'), all.dataset.skip);
      if (!list.length) return;
      all.dataset.busy = '1'; all.setAttribute('aria-disabled', 'true');  // niente doppio tocco mentre i prodotti si appoggiano
      try {
        await add(list.map(lineFor), list);
        say(list.length === 1 ? T('aggiunto_1') : T('aggiunti_n', { n: list.length }));
      } catch (msg) { say(msg); }
      delete all.dataset.busy; all.removeAttribute('aria-disabled'); paintPages(); all.focus();
      return;
    }
    if (e.target.closest('[data-open-rules]')) {
      const d = document.getElementById('regole'); if (d) d.open = true;
    }
  });

  // ---------------------------------------------------------------- scheda prodotto
  const form = document.querySelector('[data-buy-form]');
  if (form) {
    const qty = form.querySelector('[data-qty]'), hint = form.querySelector('[data-hint]');
    const buys = document.querySelectorAll('[data-buy]');
    const sel = form.querySelector('[data-variant]');
    const vid = () => sel ? sel.value : form.querySelector('[name="id"]').value;
    let inQ = +buys[0].dataset.in || 0;
    if (inQ) qty.value = inQ;
    const max = () => +qty.max || 99;
    let tocco = false;  // «hai raggiunto la quantità» solo dopo che il cliente l'ha cambiata, non all'apertura
    const paintBuy = () => {
      const q = +qty.value;
      form.querySelector('[data-q="-1"]').disabled = q <= 1;
      form.querySelector('[data-q="1"]').disabled = q >= max();
      hint.textContent = tocco && q >= max() && max() < 99 ? T('qty_max') : '';
      buys.forEach(b => {
        const corto = b.closest('[data-sticky]') ? '_breve' : '';
        b.dataset.go = inQ && inQ === q ? '1' : '';
        b.textContent = !inQ ? b.dataset.label : inQ !== q ? T('pdp_aggiorna' + corto, { n: q }) : T('pdp_vai' + corto, { n: inQ });
      });
    };
    form.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => {
      tocco = true; qty.value = Math.max(1, Math.min(max(), +qty.value + +b.dataset.q)); paintBuy();
    }));
    qty.addEventListener('input', () => { tocco = true; paintBuy(); });
    sel?.addEventListener('change', () => {
      const o = sel.selectedOptions[0];
      document.querySelector('[data-price]').textContent = o.dataset.price;
      inQ = inCart.get(sel.value) || 0; paintBuy();
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (buys[0].dataset.go) { location.href = C.cartUrl; return; }
      const q = Math.max(1, Math.min(max(), +qty.value));
      // niente disabled: il pulsante perderebbe il focus; aria-disabled e un flag bloccano il doppio tocco
      if (form.dataset.busy) return;
      form.dataset.busy = '1'; buys.forEach(b => b.setAttribute('aria-disabled', 'true'));
      try {
        if (inQ) {
          await api('cart/change.js', { id: vid(), quantity: q });
          say(T('qty_aggiornata', { n: q }));
        } else {
          const r = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const j = await r.json();
          if (!r.ok) throw j;
          say(T(form.querySelector('[name^="properties"]') ? 'preordine_nel_carrello' : 'nel_carrello', { t: document.querySelector('.buy h1').textContent }));
          replay(document.querySelector('.pdp .big'), 'press');
        }
        await refresh(true);
        inQ = q; hint.textContent = '';
      } catch (err) {
        hint.textContent = err.description || err.message || T('errore');
      }
      delete form.dataset.busy; buys.forEach(b => b.removeAttribute('aria-disabled'));
      paintBuy();
    });
    buys.forEach(b => { if (b.form !== form) b.addEventListener('click', e => { if (b.dataset.go) { e.preventDefault(); location.href = C.cartUrl; } }); });
    paintBuy();
    const sticky = document.querySelector('[data-sticky]'), main = form.querySelector('[data-buy]');
    if (sticky && main) new IntersectionObserver(([en]) => sticky.classList.toggle('is-away', !en.isIntersecting)).observe(main);

    // galleria: la miniatura diventa la foto grande
    const big = document.querySelector('[data-big]');
    document.querySelectorAll('[data-thumb]').forEach(t => t.addEventListener('click', () => {
      const img = big.querySelector('img'); if (!img) return;
      img.srcset = ''; img.src = t.dataset.thumb;
      big.classList.toggle('ph--tile', !t.dataset.cut);
      document.querySelectorAll('[data-thumb]').forEach(x => x.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
    }));
  }
  // descrizione lunga: chiusa a metà con «Leggi tutto» (senza JavaScript resta aperta)
  document.querySelectorAll('[data-desc-more]').forEach(b => {
    const box = b.closest('[data-desc]');
    const imposta = chiuso => { box.classList.toggle('is-chiuso', chiuso); b.setAttribute('aria-expanded', String(!chiuso)); b.textContent = chiuso ? b.dataset.apri : b.dataset.chiudi; };
    b.hidden = false; imposta(true);
    b.addEventListener('click', () => imposta(!box.classList.contains('is-chiuso')));
  });
  if (location.hash === '#regole') { const d = document.getElementById('regole'); if (d) d.open = true; }

  // ---------------------------------------------------------------- carrello: righe, «Rimetti nel carrello», scelta di spedizione
  const box = () => document.querySelector('[data-cart-section]');
  let removed = null;
  async function rerender() {
    const b = box(); if (!b) return;
    const html = await (await fetch(`${location.pathname}?section_id=${b.dataset.cartSection}`)).text();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (fresh) b.innerHTML = fresh.innerHTML;
    const u = box().querySelector('[data-undo]');
    if (u && removed) { u.hidden = false; u.querySelector('span').textContent = T('undo', { t: removed.t }); }
  }
  if (box()) {
    document.addEventListener('click', async e => {
      const a = e.target.closest('[data-cart-section] [data-change]');
      if (a) {
        e.preventDefault();
        const line = a.closest('.line'), dir = a.textContent;
        if (a.hasAttribute('data-remove')) {
          const props = {};
          (line.dataset.props || '').split('¶').filter(Boolean).forEach(p => { const [k, v] = p.split('§'); props[k] = v; });
          removed = { id: +line.dataset.v, quantity: +line.dataset.qty, properties: props, t: line.dataset.t };
        } else removed = null;
        try {
          const c = await api('cart/change.js', { line: +a.dataset.change, quantity: +a.dataset.q });
          paintCount(c.item_count, false);
          await rerender();
          say(removed ? T('undo', { t: removed.t }) : T('qty_di', { t: line.dataset.t, n: a.dataset.q }));
          const again = [...box().querySelectorAll(`.line[data-line="${a.dataset.change}"] a[data-change]`)].find(x => x.textContent === dir);
          (removed ? box().querySelector('[data-undo] button') : again)?.focus();
        } catch { say(T('errore')); }
        return;
      }
      if (e.target.closest('[data-cart-section] [data-undo] button') && removed) {
        const r = removed; removed = null;
        try {
          const it = { id: r.id, quantity: r.quantity };
          if (Object.keys(r.properties).length) it.properties = r.properties;
          await api('cart/add.js', { items: [it] });
          const c = await api('cart.js'); paintCount(c.item_count, true);
          await rerender();
          say(T('rimesso', { t: r.t }));
        } catch { say(T('errore')); }
      }
    });
    document.addEventListener('change', async e => {
      const r = e.target.closest('[data-cart-section] [data-ship]');
      if (!r) return;
      try { await api('cart/update.js', { attributes: { Spedizione: r.value } }); await rerender(); say(T('spedizione', { v: r.value })); } catch { say(T('errore')); }
    });
  }

  // ---------------------------------------------------------------- «Avvisami»: dopo l'invio Shopify torna qui con ?contact_posted=true#id
  if (new URLSearchParams(location.search).get('contact_posted') === 'true' && location.hash) {
    const f = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (f && f.matches('[data-notify-form]')) {
      f.querySelectorAll('.notify-row,.notify-small').forEach(x => { x.hidden = true; });
      const ok = f.querySelector('.notify-ok'); ok.hidden = false; ok.tabIndex = -1;
      const d = f.closest('details'); if (d) d.open = true;
      ok.scrollIntoView({ block: 'center' }); ok.focus();
    }
  }

  // ---------------------------------------------------------------- lingua
  document.querySelectorAll('[data-autosubmit]').forEach(s => s.addEventListener('change', () => s.form.submit()));

  // ---------------------------------------------------------------- telefono: la fila parte dal primo prodotto che si può prendere
  document.querySelectorAll('.slots--row').forEach(r => {
    if (r.scrollWidth <= r.clientWidth) return;
    const f = [...r.querySelectorAll('.slot[data-v]')].find(buyable);
    if (f && f.previousElementSibling) r.scrollLeft = f.offsetLeft - r.firstElementChild.offsetLeft;
  });

  // ---------------------------------------------------------------- menu del telefono: si apre sotto la testata, si chiude con Esc o fuori
  const mbtn = document.querySelector('[data-menu-btn]'), mnav = document.getElementById('menu');
  if (mbtn && mnav) {
    const icons = { menu: mbtn.innerHTML, close: '<svg class="i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' };
    const set = open => {
      mbtn.setAttribute('aria-expanded', open); mbtn.setAttribute('aria-label', T(open ? 'menu_chiudi' : 'menu'));
      mbtn.innerHTML = open ? icons.close : icons.menu; mnav.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) mnav.querySelector('a')?.focus();
    };
    mbtn.addEventListener('click', () => set(mnav.hidden));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !mnav.hidden) { set(false); mbtn.focus(); } });
    document.addEventListener('click', e => { const p = e.composedPath(); if (!mnav.hidden && !p.includes(mnav) && !p.includes(mbtn)) set(false); });
  }
})();
